import React, { useEffect } from "react";
import { colors } from "../../../../utils/theme";
import styled from "styled-components";
import { useDataContex } from "../../../../hooks/Context/PatientProvider";
import { useNavigate } from "react-router-dom";

const ContainerUpdatePatient = styled.div`
  margin-bottom: 3rem;
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 2rem;
    justify-content: center;
  }

  .title {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    display: block;

    @media (max-width: 600px) {
      font-size: 1.3rem;
      text-align: center;
    }
  }
`;

const ContainerFormInfo = styled.div`
  width: 95%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin: 0 auto;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }

  .Form1 {
    width: 47%;

    @media (max-width: 1024px) {
      width: 95%;
    }
  }

  .Form2 {
    width: 47%;
    @media (max-width: 1024px) {
      width: 95%;
    }
  }
`;

const FormInputInfo = styled.div`
  display: flex;
  margin-bottom: 1rem;
  gap: 20px;
  align-items: center;
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }
  label {
    width: 20%;
    color: ${colors.third};
    font-weight: 600;
    @media (max-width: 1024px) {
      text-align: center;
    }
    @media (max-width: 500px) {
      text-align: start;
      width: 100%;
    }
  }

  input {
    width: 80%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }

  .identificacion {
    width: 10%;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 20%;
    }
  }

  .id_option {
    width: 90%;
  }

  .ID {
    width: 80%;
    display: flex;
    gap: 20px;

    @media (max-width: 500px) {
      width: 100%;
    }
  }

  .radio-input {
    display: flex;

    gap: 10px;
    span {
      color: ${colors.fifth};
    }
    .radio {
      width: 1.5rem;
      height: auto;
    }
  }
`;

const handleInputChange = (newValue) => {
  console.log("");
};

export const SumarySchedComponentContinuidad = ({paciente}) => {



  return (
    <ContainerUpdatePatient>
      {/* contenedor de los formularios y los fields */}
      <div className="paginator">
        <span className="title">RESUMEN DE AGENDAMIENTO</span>
      </div>

      <ContainerFormInfo>
        {/* -------------------------- */}
        <div className="Form1">
          <FormInputInfo>
            <label>DOCUMENTO ID</label>
            <div className="ID">
              <input
                className="identificacion"
                type="text"
                value={paciente.typeId
                }
                onChange={(e) => handleInputChange(e.target.value)}
              />
              <input
                className="id_option"
                type="number"
                value={paciente.patient_Id}
                onChange={(e) => handleInputChange(e.target.value)}
              />
            </div>
          </FormInputInfo>

          <FormInputInfo>
            <label>NOMBRE</label>
            <input
              type="text"
              value={paciente.nombre}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>F. NACIMIENTO</label>
            <input
              type="text"
              value={paciente.pateint_Birthdate}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>TELÉFONO MOVIL</label>
            <input
              type="text"
              value={paciente.celular}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>EMAIL</label>
            <input
              type="text"
              value={paciente.p_Email}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>
        </div>

        {/* ------------------------- */}
        <div className="Form2">
          <FormInputInfo>
            <label>ENTIDAD</label>
            <input
              type="text"
              value={paciente.areaAfectada}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>ÁREA AFECTADA</label>
            <input
              type="text"
              value={paciente.poliza}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>
        </div>
      </ContainerFormInfo>
    </ContainerUpdatePatient>
  );
};
